/**TODO: use moment.js  */
export const EMPTY_FILTERS = {
  dateRange: {
    from: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
    to: new Date(),
  },
  product: "all",
  userType: "all",
};
